import axios from 'axios';

export interface GetAccessTokenResponse {
  refreshToken: string;
  token: string;
}

export function getAccessToken(accessToken: string, inviteGuid?: string | null) {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  };

  if (inviteGuid) {
    headers['BL-INV'] = inviteGuid;
  }

  return axios.get<GetAccessTokenResponse>(`${process.env.NEXT_PUBLIC_AUTH_API_URL}/api/Access/GetAccessToken`, { headers });
}
